const STORAGE_KEY = 'portal_theme';
const VALID_THEMES = ['dark', 'light'];

export function applyTheme(theme) {
  const t = VALID_THEMES.includes(theme) ? theme : 'light';
  document.documentElement.setAttribute('data-theme', t);
}

export function saveTheme(theme) {
  const t = VALID_THEMES.includes(theme) ? theme : 'light';
  localStorage.setItem(STORAGE_KEY, t);
  applyTheme(t);
}

export function getSavedTheme() {
  return localStorage.getItem(STORAGE_KEY) || 'light';
}

export function initTheme() {
  applyTheme(getSavedTheme());
}
